// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./background-colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: var(--wrapper-bg);
}

button.btn-custom {
    background-color: var(--button-background);
    color: var(--whitefont-color);
    box-shadow: var(--button-box-shadow);
}

button.btn-custom:hover {
    background-color: var(--button-background-hover);
    color: var(--whitefont-color);
  }


  button.btn-Modify {
    background-color: var(--Modify-btn-bg-color);
    color: var(--Modify-btn-txt-color);
    box-shadow: var(--button-box-shadow);
}

/* button.btn-Modify:hover {
    background-color: var(--Modify-btn-bg-color);
    color: var(--Modify-btn-txt-color);
  } */


  button.btn-Modify:hover,
  button.btn-Modify:active,
  button.btn-Modify:focus {
    background-color: var(--Modify-btn-bg-color) !important;
    color: var(--Modify-btn-txt-color) !important;
    border-color: var(--Modify-btn-bg-color) !important; /* Optional */
    box-shadow: none !important; /* Optional: removes Bootstrap glow */
}





  button.btn-AddData {
    background-color: var(--AddData-btn-bg-color);
    color: var(--AddData-btn-txt-color);
    border-color: var(--AddData-btn-bg-color); /* Optional: match the border */
    transition: background-color 0.2s ease, color 0.2s ease; /* Smooth effect */
}



button.btn-AddData:hover,
button.btn-AddData:active,
button.btn-AddData:focus {
    background-color: var(--AddData-btn-bg-color) !important;
    color: var(--AddData-btn-txt-color) !important;
    border-color: var(--AddData-btn-bg-color) !important; /* Optional */
    box-shadow: none !important; /* Optional: removes Bootstrap glow */
}

  

  button.btn-Review {
    background-color: var(--Review-btn-bg-color);
    color: var(--Review-btn-txt-color);
    box-shadow: var(--button-box-shadow);
}

/* button.btn-Review:hover {
    background-color: var(--Review-btn-bg-color);
    color: var(--Review-btn-txt-color);
  } */


  button.btn-Review:hover,
  button.btn-Review:active,
  button.btn-Review:focus {
    background-color: var(--Review-btn-bg-color) !important;
    color: var(--Review-btn-txt-color) !important;
    border-color: var(--Review-btn-bg-color) !important; /* Optional */
    box-shadow: none !important; /* Optional: removes Bootstrap glow */
}


  
button.btn-Update {
    background-color: var(--update-btn-bg-color);
    color: var(--add-row-btn-txt-color);
    box-shadow: var(--button-box-shadow);
}

/* button.btn-Update:hover {
    background-color: var(--button-background-hover);
    color: var(--whitefont-color);
  }
 */

  
  button.btn-Update:hover,
  button.btn-Update:active,
  button.btn-Update:focus {
    background-color: var(--update-btn-bg-color) !important;
    color: var(--add-row-btn-txt-color) !important;
    border-color: var(--Review-btn-bg-color) !important; /* Optional */
    box-shadow: none !important; /* Optional: removes Bootstrap glow */
}



button.btn-custom-edit {
    background-color: var(--Edit-btn-bg-color);
    color: var(--Edit-btn-txt-color);
    box-shadow: var(--button-box-shadow);
}

/* button.btn-custom-edit:hover {
    background-color: var(--button-background-hover);
    color: var(--whitefont-color);
  } */


  button.btn-custom-edit:hover,
  button.btn-custom-edit:active,
  button.btn-custom-edit:focus {
    background-color: var(--Edit-btn-bg-color) !important;
    color: var(--Edit-btn-txt-color) !important;
    border-color: var(--Edit-btn-bg-color) !important; /* Optional */
    box-shadow: none !important; /* Optional: removes Bootstrap glow */
}




  button.add-row-btn{
    background-color: var(--add-row-btn-color);
    color: var(--add-row-btn-txt-color);
  }

  /* button.add-row-btn:hover{
    background-color: var(--add-row-btn-color);
    color: var(--add-row-btn-txt-color);
  } */
  

  button.add-row-btn:hover,
  button.add-row-btn:active,
  button.add-row-btn:focus {
    background-color: var(--add-row-btn-color) !important;
    color: var(--add-row-btn-txt-color) !important;
    border-color: var(--add-row-btn-color) !important; /* Optional */
    box-shadow: none !important; /* Optional: removes Bootstrap glow */
}



  
  button.btn-delete-row{
    background-color: var(--Delete-row-color);
    color: var(--delete-row-txt-color);
  }
  
  /* button.btn-delete-row:hover{
    background-color: var(--Delete-row-color);
    color: var(--delete-row-txt-color);
  } */


  button.btn-delete-row:hover,
  button.btn-delete-row:active,
  button.btn-delete-row:focus {
    background-color: var(--Delete-row-color) !important;
    color: var(--delete-row-txt-color) !important;
    border-color: var(--Delete-row-color) !important; /* Optional */
    box-shadow: none !important; /* Optional: removes Bootstrap glow */
}



  button.update-btn{
    background-color: var(--update-btn-bg-color);
    color: var(--update-btn-txt-color);
  }

  /* button.update-btn:hover{
    background-color: var(--update-btn-bg-color);
    color: var(--update-btn-txt-color);
  } */



  button.update-btn:hover,
  button.update-btn:active,
  button.update-btn:focus {
    background-color: var(--update-btn-bg-color) !important;
    color: var(--update-btn-txt-color) !important;
    border-color: var(--update-btn-bg-color) !important; /* Optional */
    box-shadow: none !important; /* Optional: removes Bootstrap glow */
}


  
button.btn-submit {
    background-color: var(--button-background-Submit);
    color: var(--button-background-Submit-txt);
    box-shadow: var(--button-box-shadow);
}

/* button.btn-submit:hover {
    background-color: var(--button-background-submit-hover);
    color: var(--whitefont-color);
  } */



  button.btn-submit:hover,
  button.btn-submit:active,
  button.btn-submit:focus {
    background-color: var(--button-background-Submit) !important;
    color: var(--button-background-Submit-txt) !important;
    border-color: var(--button-background-Submit) !important; /* Optional */
    box-shadow: none !important; /* Optional: removes Bootstrap glow */
}


  button.Edit-btn-color
  {
  background-color: var(--Edit-btn-bg-color);  
  color: var(--Edit-btn-txt-color);
  }
  
  /* button.Edit-btn-color:hover
  {
  background-color: var(--Edit-btn-bg-color);  
  color: var(--Edit-btn-txt-color);
  } */



  button.Edit-btn-color:hover,
  button.Edit-btn-color:active,
  button.Edit-btn-color:focus {
    background-color: var(--Edit-btn-bg-color) !important;
    color: var(--Edit-btn-txt-color) !important;
    border-color: var(--Edit-btn-bg-color) !important; /* Optional */
    box-shadow: none !important; /* Optional: removes Bootstrap glow */
}



  button.btn-custom {
    background-color: var(--button-background);
    color: var(--whitefont-color);
    box-shadow: var(--button-box-shadow);
}

button.btn-custom:hover {
    background-color: var(--button-background-hover);
    color: var(--whitefont-color);
  }

button.btn-Add-Row-btn{
    background-color: var(--add-row-btn-color);
    color: var(--add-row-btn-txt-color);
    box-shadow: var(--button-box-shadow);
}

/* button.btn-Add-Row-btn:hover {
    background-color: var(--button-background-hover);
    color: var(--whitefont-color);
  } */


  button.btn-Add-Row-btn:hover,
  button.btn-Add-Row-btn:active,
  button.btn-Add-Row-btn:focus {
    background-color: var(--add-row-btn-color) !important;
    color: var(--add-row-btn-txt-color) !important;
    border-color: var(--add-row-btn-color) !important; /* Optional */
    box-shadow: none !important; /* Optional: removes Bootstrap glow */
}



.w-75 {
    width: 75% !important;
}

.table-shadow {
    box-shadow: 2px 6px 15px 0 rgba(69,65,78,.1);
}`, "",{"version":3,"sources":["webpack://./src/assets/css/DEMautotabledetails.css"],"names":[],"mappings":"AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,0CAA0C;IAC1C,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,gDAAgD;IAChD,6BAA6B;EAC/B;;;EAGA;IACE,4CAA4C;IAC5C,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;;;KAGK;;;EAGH;;;IAGE,uDAAuD;IACvD,6CAA6C;IAC7C,mDAAmD,EAAE,aAAa;IAClE,2BAA2B,EAAE,qCAAqC;AACtE;;;;;;EAME;IACE,6CAA6C;IAC7C,mCAAmC;IACnC,yCAAyC,EAAE,+BAA+B;IAC1E,uDAAuD,EAAE,kBAAkB;AAC/E;;;;AAIA;;;IAGI,wDAAwD;IACxD,8CAA8C;IAC9C,oDAAoD,EAAE,aAAa;IACnE,2BAA2B,EAAE,qCAAqC;AACtE;;;;EAIE;IACE,4CAA4C;IAC5C,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;;;KAGK;;;EAGH;;;IAGE,uDAAuD;IACvD,6CAA6C;IAC7C,mDAAmD,EAAE,aAAa;IAClE,2BAA2B,EAAE,qCAAqC;AACtE;;;;AAIA;IACI,4CAA4C;IAC5C,mCAAmC;IACnC,oCAAoC;AACxC;;AAEA;;;;EAIE;;;EAGA;;;IAGE,uDAAuD;IACvD,8CAA8C;IAC9C,mDAAmD,EAAE,aAAa;IAClE,2BAA2B,EAAE,qCAAqC;AACtE;;;;AAIA;IACI,0CAA0C;IAC1C,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;;;KAGK;;;EAGH;;;IAGE,qDAAqD;IACrD,2CAA2C;IAC3C,iDAAiD,EAAE,aAAa;IAChE,2BAA2B,EAAE,qCAAqC;AACtE;;;;;EAKE;IACE,0CAA0C;IAC1C,mCAAmC;EACrC;;EAEA;;;KAGG;;;EAGH;;;IAGE,qDAAqD;IACrD,8CAA8C;IAC9C,iDAAiD,EAAE,aAAa;IAChE,2BAA2B,EAAE,qCAAqC;AACtE;;;;;EAKE;IACE,yCAAyC;IACzC,kCAAkC;EACpC;;EAEA;;;KAGG;;;EAGH;;;IAGE,oDAAoD;IACpD,6CAA6C;IAC7C,gDAAgD,EAAE,aAAa;IAC/D,2BAA2B,EAAE,qCAAqC;AACtE;;;;EAIE;IACE,4CAA4C;IAC5C,kCAAkC;EACpC;;EAEA;;;KAGG;;;;EAIH;;;IAGE,uDAAuD;IACvD,6CAA6C;IAC7C,mDAAmD,EAAE,aAAa;IAClE,2BAA2B,EAAE,qCAAqC;AACtE;;;;AAIA;IACI,iDAAiD;IACjD,0CAA0C;IAC1C,oCAAoC;AACxC;;AAEA;;;KAGK;;;;EAIH;;;IAGE,4DAA4D;IAC5D,qDAAqD;IACrD,wDAAwD,EAAE,aAAa;IACvE,2BAA2B,EAAE,qCAAqC;AACtE;;;EAGE;;EAEA,0CAA0C;EAC1C,gCAAgC;EAChC;;EAEA;;;;KAIG;;;;EAIH;;;IAGE,qDAAqD;IACrD,2CAA2C;IAC3C,iDAAiD,EAAE,aAAa;IAChE,2BAA2B,EAAE,qCAAqC;AACtE;;;;EAIE;IACE,0CAA0C;IAC1C,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,gDAAgD;IAChD,6BAA6B;EAC/B;;AAEF;IACI,0CAA0C;IAC1C,mCAAmC;IACnC,oCAAoC;AACxC;;AAEA;;;KAGK;;;EAGH;;;IAGE,qDAAqD;IACrD,8CAA8C;IAC9C,iDAAiD,EAAE,aAAa;IAChE,2BAA2B,EAAE,qCAAqC;AACtE;;;;AAIA;IACI,qBAAqB;AACzB;;AAEA;IACI,4CAA4C;AAChD","sourcesContent":["@import './background-colors.css';\r\n\r\nbody {\r\n    background-color: var(--wrapper-bg);\r\n}\r\n\r\nbutton.btn-custom {\r\n    background-color: var(--button-background);\r\n    color: var(--whitefont-color);\r\n    box-shadow: var(--button-box-shadow);\r\n}\r\n\r\nbutton.btn-custom:hover {\r\n    background-color: var(--button-background-hover);\r\n    color: var(--whitefont-color);\r\n  }\r\n\r\n\r\n  button.btn-Modify {\r\n    background-color: var(--Modify-btn-bg-color);\r\n    color: var(--Modify-btn-txt-color);\r\n    box-shadow: var(--button-box-shadow);\r\n}\r\n\r\n/* button.btn-Modify:hover {\r\n    background-color: var(--Modify-btn-bg-color);\r\n    color: var(--Modify-btn-txt-color);\r\n  } */\r\n\r\n\r\n  button.btn-Modify:hover,\r\n  button.btn-Modify:active,\r\n  button.btn-Modify:focus {\r\n    background-color: var(--Modify-btn-bg-color) !important;\r\n    color: var(--Modify-btn-txt-color) !important;\r\n    border-color: var(--Modify-btn-bg-color) !important; /* Optional */\r\n    box-shadow: none !important; /* Optional: removes Bootstrap glow */\r\n}\r\n\r\n\r\n\r\n\r\n\r\n  button.btn-AddData {\r\n    background-color: var(--AddData-btn-bg-color);\r\n    color: var(--AddData-btn-txt-color);\r\n    border-color: var(--AddData-btn-bg-color); /* Optional: match the border */\r\n    transition: background-color 0.2s ease, color 0.2s ease; /* Smooth effect */\r\n}\r\n\r\n\r\n\r\nbutton.btn-AddData:hover,\r\nbutton.btn-AddData:active,\r\nbutton.btn-AddData:focus {\r\n    background-color: var(--AddData-btn-bg-color) !important;\r\n    color: var(--AddData-btn-txt-color) !important;\r\n    border-color: var(--AddData-btn-bg-color) !important; /* Optional */\r\n    box-shadow: none !important; /* Optional: removes Bootstrap glow */\r\n}\r\n\r\n  \r\n\r\n  button.btn-Review {\r\n    background-color: var(--Review-btn-bg-color);\r\n    color: var(--Review-btn-txt-color);\r\n    box-shadow: var(--button-box-shadow);\r\n}\r\n\r\n/* button.btn-Review:hover {\r\n    background-color: var(--Review-btn-bg-color);\r\n    color: var(--Review-btn-txt-color);\r\n  } */\r\n\r\n\r\n  button.btn-Review:hover,\r\n  button.btn-Review:active,\r\n  button.btn-Review:focus {\r\n    background-color: var(--Review-btn-bg-color) !important;\r\n    color: var(--Review-btn-txt-color) !important;\r\n    border-color: var(--Review-btn-bg-color) !important; /* Optional */\r\n    box-shadow: none !important; /* Optional: removes Bootstrap glow */\r\n}\r\n\r\n\r\n  \r\nbutton.btn-Update {\r\n    background-color: var(--update-btn-bg-color);\r\n    color: var(--add-row-btn-txt-color);\r\n    box-shadow: var(--button-box-shadow);\r\n}\r\n\r\n/* button.btn-Update:hover {\r\n    background-color: var(--button-background-hover);\r\n    color: var(--whitefont-color);\r\n  }\r\n */\r\n\r\n  \r\n  button.btn-Update:hover,\r\n  button.btn-Update:active,\r\n  button.btn-Update:focus {\r\n    background-color: var(--update-btn-bg-color) !important;\r\n    color: var(--add-row-btn-txt-color) !important;\r\n    border-color: var(--Review-btn-bg-color) !important; /* Optional */\r\n    box-shadow: none !important; /* Optional: removes Bootstrap glow */\r\n}\r\n\r\n\r\n\r\nbutton.btn-custom-edit {\r\n    background-color: var(--Edit-btn-bg-color);\r\n    color: var(--Edit-btn-txt-color);\r\n    box-shadow: var(--button-box-shadow);\r\n}\r\n\r\n/* button.btn-custom-edit:hover {\r\n    background-color: var(--button-background-hover);\r\n    color: var(--whitefont-color);\r\n  } */\r\n\r\n\r\n  button.btn-custom-edit:hover,\r\n  button.btn-custom-edit:active,\r\n  button.btn-custom-edit:focus {\r\n    background-color: var(--Edit-btn-bg-color) !important;\r\n    color: var(--Edit-btn-txt-color) !important;\r\n    border-color: var(--Edit-btn-bg-color) !important; /* Optional */\r\n    box-shadow: none !important; /* Optional: removes Bootstrap glow */\r\n}\r\n\r\n\r\n\r\n\r\n  button.add-row-btn{\r\n    background-color: var(--add-row-btn-color);\r\n    color: var(--add-row-btn-txt-color);\r\n  }\r\n\r\n  /* button.add-row-btn:hover{\r\n    background-color: var(--add-row-btn-color);\r\n    color: var(--add-row-btn-txt-color);\r\n  } */\r\n  \r\n\r\n  button.add-row-btn:hover,\r\n  button.add-row-btn:active,\r\n  button.add-row-btn:focus {\r\n    background-color: var(--add-row-btn-color) !important;\r\n    color: var(--add-row-btn-txt-color) !important;\r\n    border-color: var(--add-row-btn-color) !important; /* Optional */\r\n    box-shadow: none !important; /* Optional: removes Bootstrap glow */\r\n}\r\n\r\n\r\n\r\n  \r\n  button.btn-delete-row{\r\n    background-color: var(--Delete-row-color);\r\n    color: var(--delete-row-txt-color);\r\n  }\r\n  \r\n  /* button.btn-delete-row:hover{\r\n    background-color: var(--Delete-row-color);\r\n    color: var(--delete-row-txt-color);\r\n  } */\r\n\r\n\r\n  button.btn-delete-row:hover,\r\n  button.btn-delete-row:active,\r\n  button.btn-delete-row:focus {\r\n    background-color: var(--Delete-row-color) !important;\r\n    color: var(--delete-row-txt-color) !important;\r\n    border-color: var(--Delete-row-color) !important; /* Optional */\r\n    box-shadow: none !important; /* Optional: removes Bootstrap glow */\r\n}\r\n\r\n\r\n\r\n  button.update-btn{\r\n    background-color: var(--update-btn-bg-color);\r\n    color: var(--update-btn-txt-color);\r\n  }\r\n\r\n  /* button.update-btn:hover{\r\n    background-color: var(--update-btn-bg-color);\r\n    color: var(--update-btn-txt-color);\r\n  } */\r\n\r\n\r\n\r\n  button.update-btn:hover,\r\n  button.update-btn:active,\r\n  button.update-btn:focus {\r\n    background-color: var(--update-btn-bg-color) !important;\r\n    color: var(--update-btn-txt-color) !important;\r\n    border-color: var(--update-btn-bg-color) !important; /* Optional */\r\n    box-shadow: none !important; /* Optional: removes Bootstrap glow */\r\n}\r\n\r\n\r\n  \r\nbutton.btn-submit {\r\n    background-color: var(--button-background-Submit);\r\n    color: var(--button-background-Submit-txt);\r\n    box-shadow: var(--button-box-shadow);\r\n}\r\n\r\n/* button.btn-submit:hover {\r\n    background-color: var(--button-background-submit-hover);\r\n    color: var(--whitefont-color);\r\n  } */\r\n\r\n\r\n\r\n  button.btn-submit:hover,\r\n  button.btn-submit:active,\r\n  button.btn-submit:focus {\r\n    background-color: var(--button-background-Submit) !important;\r\n    color: var(--button-background-Submit-txt) !important;\r\n    border-color: var(--button-background-Submit) !important; /* Optional */\r\n    box-shadow: none !important; /* Optional: removes Bootstrap glow */\r\n}\r\n\r\n\r\n  button.Edit-btn-color\r\n  {\r\n  background-color: var(--Edit-btn-bg-color);  \r\n  color: var(--Edit-btn-txt-color);\r\n  }\r\n  \r\n  /* button.Edit-btn-color:hover\r\n  {\r\n  background-color: var(--Edit-btn-bg-color);  \r\n  color: var(--Edit-btn-txt-color);\r\n  } */\r\n\r\n\r\n\r\n  button.Edit-btn-color:hover,\r\n  button.Edit-btn-color:active,\r\n  button.Edit-btn-color:focus {\r\n    background-color: var(--Edit-btn-bg-color) !important;\r\n    color: var(--Edit-btn-txt-color) !important;\r\n    border-color: var(--Edit-btn-bg-color) !important; /* Optional */\r\n    box-shadow: none !important; /* Optional: removes Bootstrap glow */\r\n}\r\n\r\n\r\n\r\n  button.btn-custom {\r\n    background-color: var(--button-background);\r\n    color: var(--whitefont-color);\r\n    box-shadow: var(--button-box-shadow);\r\n}\r\n\r\nbutton.btn-custom:hover {\r\n    background-color: var(--button-background-hover);\r\n    color: var(--whitefont-color);\r\n  }\r\n\r\nbutton.btn-Add-Row-btn{\r\n    background-color: var(--add-row-btn-color);\r\n    color: var(--add-row-btn-txt-color);\r\n    box-shadow: var(--button-box-shadow);\r\n}\r\n\r\n/* button.btn-Add-Row-btn:hover {\r\n    background-color: var(--button-background-hover);\r\n    color: var(--whitefont-color);\r\n  } */\r\n\r\n\r\n  button.btn-Add-Row-btn:hover,\r\n  button.btn-Add-Row-btn:active,\r\n  button.btn-Add-Row-btn:focus {\r\n    background-color: var(--add-row-btn-color) !important;\r\n    color: var(--add-row-btn-txt-color) !important;\r\n    border-color: var(--add-row-btn-color) !important; /* Optional */\r\n    box-shadow: none !important; /* Optional: removes Bootstrap glow */\r\n}\r\n\r\n\r\n\r\n.w-75 {\r\n    width: 75% !important;\r\n}\r\n\r\n.table-shadow {\r\n    box-shadow: 2px 6px 15px 0 rgba(69,65,78,.1);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
